import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_PATH} from '../constants';
import {QuestionFlowSessionQuery} from '../questions/state/question-flow-session.query';
import {Question} from '../models/underwriter.model';

@Injectable({
  providedIn: 'root'
})
export class VapService {

  constructor(
    private http: HttpClient,
    private questionFlowSessionQuery: QuestionFlowSessionQuery
  ) {
  }

  getMiniFlowItems(vaps_id: number, class_id: number, flow_id: number, parent_question_id: number, item_id?: string): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('category_id', session_details?.category_id);
    parameters.set('class_id', class_id?.toString());
    parameters.set('flow_id', flow_id.toString());
    parameters.set('group_id', session_details?.group_id?.toString());
    parameters.set('vaps_id', vaps_id?.toString());
    parameters.set('question_id_parent', parent_question_id?.toString());
    if (item_id) {
      parameters.set('item_id', item_id);
    }
    return this.runCommandNew('getMiniFlow_player_items', parameters);
  }

  getFlowQuestions(vaps_id: number, flow_id: number, item_id: string): Observable<any[]> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('category_id', session_details?.category_id);
    parameters.set('group_id', session_details?.group_id);
    parameters.set('flow_id', flow_id?.toString());
    parameters.set('vaps_id', vaps_id?.toString());
    parameters.set('item_id', item_id);

    return this.runCommandNew('getFlowQuestions', parameters);
  }

  saveAnswer(question: Question, class_id: number, item_id: string, flow_id: number, vap_id: number, response_parameters = ''): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();

    parameters.set('session_id', session_details?.session_id);
    parameters.set('answer', question?.answer);
    parameters.set('question_id', question?.cent_aq_question_id.toString());
    parameters.set('product_class_id', class_id.toString());
    parameters.set('item_id', item_id);
    parameters.set('answer_id', question?.answer_id.toString());
    parameters.set('flow_id', flow_id?.toString());
    parameters.set('vaps_id', vap_id?.toString());
    if (response_parameters) {
      parameters.set('parameters', response_parameters);
    }

    return this.runCommandNew('saveAnswer', parameters);
  }

  getNext(item_id: string, question_id: number, flow_id: number): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('item_id', item_id);
    parameters.set('question_id', question_id?.toString());
    parameters.set('flow_id', flow_id?.toString());

    return this.runCommandNew('getNext', parameters);
  }

  getVapQuestion(class_id: number, vap_id: number): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('category_id', session_details?.category_id);
    parameters.set('group_id', session_details?.group_id);
    parameters.set('class_id', class_id.toString());
    parameters.set('vap_id', vap_id.toString());

    return this.runCommandNew('getVapQuestions', parameters);
  }

  addBenefits(class_id: number, vap_id: number, item_id: string, flow_id: number): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('class_id', class_id?.toString());
    parameters.set('item_id', item_id);
    parameters.set('vaps_id', vap_id?.toString());
    parameters.set('flow_id', flow_id?.toString());

    return this.runCommandNew('addBenefit', parameters);
  }

  removeBenefit(class_id: number, vap_id: number, item_id: string): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);
    parameters.set('class_id', class_id?.toString());
    parameters.set('vaps_id', vap_id?.toString());
    parameters.set('item_id', item_id);

    return this.runCommandNew('removeBenefit', parameters);
  }

  calcPremiumAddons(vap_id: number, item_id: string, product_id: number): Observable<any> {
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    console.log('product_id', product_id)

    parameters.set('session_id', session_details?.session_id);
    parameters.set('product_vaps_input', vap_id?.toString());
    parameters.set('item_id', item_id);
    parameters.set('product_id', product_id?.toString());
    parameters.set('category_id', session_details?.category_id);

    return this.runCommandNew('calcPrem_addons_2', parameters);
  }

  runCommandNew(command: string, parameters: Map<string, string>, multiple: boolean = false): Observable<any> {
    const parametersObject = {};
    for (const [key, value] of parameters) {
      parametersObject[key] = value;
    }

    const requestBody: any = {
      Parameters: parametersObject,
      Command: command,
      Dataset: multiple
    };

    return this.http.post(`${API_PATH.RUN_NEW_COMMAND}`, requestBody);
  }

  runCommand(command: string): Observable<any> {
    return this.http.get(`${API_PATH.RUN_COMMAND}/${command}`);
  }

  replaceCallProcParameters(call_proc: string, item_id: any, class_id: any, question_id: any, flow_id: any, vap_id: any, page = ''): any {
    const session_details = this.questionFlowSessionQuery.getValue();
    return call_proc
      .replace(/{session_id}/g, session_details?.session_id)
      .replace(/{item_id}/g, item_id)
      .replace(/{page}/g, page)
      .replace(/{class_id}/g, class_id)
      .replace(/{question_id}/g, question_id)
      .replace(/{flow_id}/g, flow_id)
      .replace(/{group_id}/g, session_details?.group_id)
      .replace(/{vaps_id}/g, vap_id)
      .replace(/{category_id}/g, session_details?.category_id);
  }
}
